export interface IBissPorts {
    version: number;             // "version": "2.16",
    httpMethods: string;         // "httpMethods": "GET, POST",
    contentTypes: string;        // "contentTypes": "data, digest",
    signatureTypes: string;      // "signatureTypes": "signature",
    selectorAvailable: boolean;   // "selectorAvailable": true,
    hashAlgorithms: string;       // "hashAlgorithms": "SHA1, SHA256, SHA384, SHA512"
}

export interface IBissSignedJson {
    status: string;
    code: string;
    message: string;
    singedJsonObject: string;
  }
export interface IBIssDialogData {
  verificationMessage: string;
  operationMessage: string;
}
  export class BissError implements Error {
    name = 'BissError';
    message: string;
    stack?: string;

    constructor(message: string) {
        this.message = message;
    }    
}
export class SignedContent {
    constructor(
        public content: string,
        public signedContent: string,
        public signedContentCert: string,
        public digestTime: number,
        public originalContent: string,

        public filename: string = '',
        public type: string = '') {
    }
}
export interface IBissSignedResponse {
    code: string;
    message: string;
    status: number;
    data: any;

    // data object contains:

    // confirmText: any;       // null no confirmation window, or string to be confirmation window text
    // contentType: string;    // "digest"
    // contents: [];           // array with one random string
    // hashAlgorithm: string;  // "SHA256" hardcoded hashalgorithm
    // signatureType: string;  // "signature"
    // signedContents: [];
    // signedContentsCert: [];
    // signerCertificateB64: string; // base64 encoded cert who was chosen in begining from chains[0]
    // version: string;  // "2.16"
}
export interface IBissResponseGetSigner {
    chain: string[];      // [] with 3 items we usually use [0]
    reasonCode: number;  // 200
    reasonText: string;  // "Операцията завърши успешно"
    status: string;      // status: "ok"
}
export interface ISpringResponseBody {
    code: string;
    message: string;
    status: number;
    field?: string;
    data?: any;
}
export enum EventType {
    DOWNLOAD_BISS = 'DOWNLOAD_BISS',
    FIND_BISS_ACTIVE_PORT = 'FIND_BISS_ACTIVE_PORT',
    FIND_BISS_CERT = 'FIND_BISS_CERT',
    BISS_SIGN_DOC = 'BISS_SIGN_DOC'
}
export enum BissFailCallbackType {
    RETRY,
    DOWNLOAD
}
